import ListProductOther from './ListProductOther.jsx';
import ItemProductOther from './ItemProductOther.jsx';

export {
  ListProductOther,
  ItemProductOther
}


// WEBPACK FOOTER //
// ./components/product-detail/sub-view/list-product-other/index.js